import styled from 'styled-components';

export const Frame = styled('iframe')`
  width: 100%;
  height: ${({ theme }) =>
    `calc(100vh - ${theme.desktopTopbarHeight + theme.x6spacePx}px)`};
  border: 0;
`;
